import styled, { css } from 'styled-components';
var Input = styled.div.withConfig({
  displayName: "StyledInput__Input",
  componentId: "dcjmk7-0"
})(["background:transparent;border:1px solid ", ";border-radius:8px;padding:13px 16px 12px 16px;font-family:", ";overflow:hidden;text-overflow:ellipsis;transition:all 0.3s ease;font-size:14px;line-height:20px;color:", ";-webkit-appearance:none;::placeholder{font-size:14px;line-height:24px;overflow:hidden;text-overflow:ellipsis;", "}", " ", " &:focus{border-color:", ";color:", ";outline:none;}", ";", ";&.input__invalid{border:1px solid ", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.gray700;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray800;
}, function (_ref4) {
  var theme = _ref4.theme;
  return css(["font-family:", ";color:", ";"], theme.fontFamily, theme.colors.gray800);
}, function (_ref5) {
  var typeInput = _ref5.typeInput,
    variant = _ref5.variant;
  return typeInput === 'numberInput' && variant === 'skipper' && css(["text-align:center;font-size:12px;line-height:18px;font-weight:400;::-webkit-inner-spin-button{-webkit-appearance:none;}::-webkit-outer-spin-button{-webkit-appearance:none;}"]);
}, function (_ref6) {
  var disabled = _ref6.disabled,
    theme = _ref6.theme;
  return disabled && css(["border:1px solid ", ";-webkit-text-fill-color:", ";color:", ";border-radius:8px;pointer-events:none;opacity:1;"], theme.colors.gray600, theme.colors.gray600, theme.colors.gray600);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blue600;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.gray900;
}, function (_ref9) {
  var value = _ref9.value;
  return value && css(["color:", ";"], function (_ref0) {
    var theme = _ref0.theme;
    return theme.colors.gray900;
  });
}, function (_ref1) {
  var animate = _ref1.animate,
    theme = _ref1.theme,
    hasError = _ref1.hasError;
  return animate && !hasError && css(["&:focus + div > label{color:", ";}"], theme.colors.blue600);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.red600;
});
var StyledError = styled.span.withConfig({
  displayName: "StyledInput__StyledError",
  componentId: "dcjmk7-1"
})(["color:", ";font-size:12px;line-height:18px;font-weight:500;letter-spacing:-0.1px;margin-top:4px;font-family:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.red600;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily;
});
var HelpMsg = styled.span.withConfig({
  displayName: "StyledInput__HelpMsg",
  componentId: "dcjmk7-2"
})(["color:", ";font-size:12px;line-height:18px;font-weight:500;margin-top:4px;letter-spacing:-0.1px;font-family:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.gray800;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontFamily;
});
var InputContainer = styled.div.withConfig({
  displayName: "StyledInput__InputContainer",
  componentId: "dcjmk7-3"
})(["display:flex;flex-direction:column;position:relative;input:-webkit-autofill,input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus{-webkit-text-fill-color:", ";-webkit-box-shadow:0 0 0px 1000px rgba(255,255,255,0) inset;transition:background-color 5000s ease-in-out 0s;}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.gray900;
});
var Label = styled.label.withConfig({
  displayName: "StyledInput__Label",
  componentId: "dcjmk7-4"
})(["align-items:center;font-family:", ";transition:all 100ms ease;position:absolute;top:14px;padding:0px 0px 0px 16px;font-weight:normal;cursor:text;font-size:14px;line-height:19px;pointer-events:none;color:", ";display:flex;opacity:", ";", ""], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontFamily;
}, function (_ref17) {
  var theme = _ref17.theme,
    disabled = _ref17.disabled,
    isFocus = _ref17.isFocus;
  return disabled ? theme.colors.gray600 : isFocus ? theme.colors.gray900 : theme.colors.gray800;
}, function (_ref18) {
  var hasPlaceholder = _ref18.hasPlaceholder;
  return hasPlaceholder ? '0' : '1';
}, function (_ref19) {
  var theme = _ref19.theme,
    hasError = _ref19.hasError,
    isFocus = _ref19.isFocus,
    value = _ref19.value,
    disabled = _ref19.disabled;
  return (value || value === 0) && css(["opacity:1;font-size:12px;line-height:18px;top:-8px;left:12px;color:", ";background-color:white;padding:0px 4px;z-index:1;"], disabled ? theme.colors.gray600 : hasError ? theme.colors.red600 : isFocus ? theme.colors.blue600 : theme.colors.gray800);
});
var IconContainer = styled.div.withConfig({
  displayName: "StyledInput__IconContainer",
  componentId: "dcjmk7-5"
})(["position:absolute;right:10px;top:10px;z-index:1;", ""], function (_ref20) {
  var hasClear = _ref20.hasClear;
  return hasClear && css(["cursor:pointer;"]);
});
var IconAlign = styled.a.withConfig({
  displayName: "StyledInput__IconAlign",
  componentId: "dcjmk7-6"
})(["", " position:absolute;top:12px;z-index:1;cursor:pointer;", " ", " ", ";", ";"], function (_ref21) {
  var variant = _ref21.variant;
  return variant !== 'skipper' && css(["display:none;"]);
}, function (_ref22) {
  var disabled = _ref22.disabled;
  return disabled && css(["cursor:auto;"]);
}, function (_ref23) {
  var value = _ref23.value,
    number = _ref23.number;
  return value === number && css(["cursor:auto;"]);
}, function (_ref24) {
  var align = _ref24.align;
  return align === 'left' && css(["left:10px;"]);
}, function (_ref25) {
  var align = _ref25.align;
  return align === 'right' && css(["right:10px;"]);
});
var LimitCharactersContainer = styled.div.withConfig({
  displayName: "StyledInput__LimitCharactersContainer",
  componentId: "dcjmk7-7"
})(["display:flex;justify-content:space-between;"]);
export { Input, InputContainer, Label, StyledError, HelpMsg, IconContainer, IconAlign, LimitCharactersContainer };